import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  float: left;
  position: relative;
`

export const LabelContainer = styled.div`
  width: 100%;
  height: 40px;
  position: relative;
  top: 152px;
  left: 3%;
  margin-top: -10px;
  line-height: 19px;
  text-align: center;
  z-index: 99;
`

interface LabelProps {
  color: string
}

export const Label = styled.span<LabelProps>`
  font-size: 2rem;
  font-weight: bold;
  color: ${({ color }) => color};
`
